import React from 'react';
import Agreement from './Agreement';

function AgreementPage() {
  return <Agreement />;
}

export default AgreementPage;
